/* eslint-disable react/sort-prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import {
  Card,
  Heading,
  Form,
  FormLayout,
  TextField,
  Button,
  Link,
} from '@shopify/polaris';
import styleConstants from 'src/styles/constants';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import validations from './validattions';
import { validateFields } from '../../utils/validations';
import { RECOVERY_PASSWORD_URL } from './constants';
import SignInMutation from '../../mutations/SignInMutation';

const SessionExpired = ({ shop, session, tenant, onSuccess, onError }) => {
  const [password, setPassword] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [onSignin, { loading }] = useMutation(SignInMutation);

  const onSubmit = async (e) => {
    e.preventDefault();
    const submitErrors = validateFields({ password }, validations);
    if (Object.keys(submitErrors).length) {
      return setValidationErrors(submitErrors);
    }

    const { subdomain } = tenant;
    const { email } = session;
    const variables = {
      email,
      shop,
      subdomain,
      password,
    };

    try {
      const { data } = await onSignin({ variables });
      if (data && !data.signIn.result.success) {
        const { errors } = data.signIn.result;
        if (errors.length > 1) {
          return onError({
            title: 'Sign in unsuccessful.',
            message: errors.map(({ message }) => message),
          });
        }
        return onError(errors[0]);
      }
      const { tenant: newTenant, ...newSession } = data.signIn.session;
      return onSuccess(newSession, newTenant);
    } catch (err) {
      const error = {
        title: 'Sign in unsuccessful.',
        message: err.message,
      };
      return onError(error);
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Card>
        <Card.Section>
          <header>
            {tenant && <Heading element="h5">{tenant.name}</Heading>}
          </header>
          <FormLayout>
            <TextField
              error={
                validationErrors.password && (
                  <span>{validationErrors.password.required}</span>
                )
              }
              label="Password"
              type="password"
              value={password}
              onChange={(value) => setPassword(value)}
            />
          </FormLayout>
          <footer>
            <Link url={RECOVERY_PASSWORD_URL} external>
              Forgot password?
            </Link>
            <Button loading={loading} primary submit>
              Log in
            </Button>
          </footer>
        </Card.Section>
      </Card>
      <style jsx>{`
        header > :global(.Polaris-Heading) {
          margin-bottom: ${styleConstants.spacing.six};
        }
        footer {
          display: flex;
          flex-direction: column;
          padding-top: ${styleConstants.spacing.two};
        }
        footer > :global(.Polaris-Link) {
          margin-bottom: ${styleConstants.spacing.five};
        }
      `}</style>
    </Form>
  );
};

SessionExpired.defaultProps = {
  session: null,
  tenant: null,
};
SessionExpired.propTypes = {
  shop: PropTypes.string.isRequired,
  session: PropTypes.shape({
    email: PropTypes.string,
  }),
  tenant: PropTypes.shape({
    name: PropTypes.string,
    subdomain: PropTypes.string,
  }),
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default SessionExpired;
